// extracted by mini-css-extract-plugin
module.exports = {"lightTheme":"nvrt-light_theme","darkTheme":"nvrt-dark_theme","select":"select_select__2NPoH"};